/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProviderOption } from './ProviderOption';
import {
    ProviderOptionFromJSON,
    ProviderOptionFromJSONTyped,
    ProviderOptionToJSON,
} from './ProviderOption';

/**
 * 
 * @export
 * @interface ProviderListResponse
 */
export interface ProviderListResponse {
    /**
     * 
     * @type {Array<ProviderOption>}
     * @memberof ProviderListResponse
     */
    providerList: Array<ProviderOption>;
}

/**
 * Check if a given object implements the ProviderListResponse interface.
 */
export function instanceOfProviderListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "providerList" in value;

    return isInstance;
}

export function ProviderListResponseFromJSON(json: any): ProviderListResponse {
    return ProviderListResponseFromJSONTyped(json, false);
}

export function ProviderListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'providerList': ((json['providerList'] as Array<any>).map(ProviderOptionFromJSON)),
    };
}

export function ProviderListResponseToJSON(value?: ProviderListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'providerList': ((value.providerList as Array<any>).map(ProviderOptionToJSON)),
    };
}

